import axios from "axios";

export default {
    login(body) {
        return axios.post("login", body);
    },
    user() {
        return axios.get("user");
    }
};
